// Common
import { callQBookingApi } from "./common";

// Utils
import { get, post, patch, put } from "Utils/HTTPMethods";

// Redux
import store from "Store/Store";

export const getAppointmentsByPatientId = async (patientId) => {
  return callQBookingApi(get, "/appointment", { patientId });
};

/**
 * @param {String} ageGroup - one from  ALL, YOUNG, ADULT
 * @param {String} reasonForVisit - the reason for the visit (clinic.appointmentSuggestions[].type)
 * @param {String} location - The clinic location (clinic.location)
 * @param {String} clinicId - the clinic id (to get appointments for a specific clinic)
 * @param {String|null} clientId - the client id (to get appointments with respect to a specific client)
 * @return - all free appointments for all clinics and reason for visit types
 */
export const getAvailableAppointments = async (
  ageGroup = "ALL",
  reasonForVisit = null,
  location = null,
  clinicId = null,
  clientId = null
) => {
  const clientIdParam = clientId || store.getState().client.client?.id;

  const params = {
    ageGroup,
    ...(reasonForVisit && { reasonForVisit }),
    ...(location && { location }),
    ...(clinicId && { clinicId }),
    clientId: clientIdParam,
  };
  return callQBookingApi(get, "/appointment", params);
};

export const bookAppointment = async (appointment) => {
  return callQBookingApi(post, "/appointment", appointment);
};

export const cancelAppointment = async (id) => {
  return callQBookingApi(patch, "/appointment", { id, action: "cancel" });
};

export const rescheduleAppointment = async (
  newAppointment,
  currentAppointment
) => {
  return callQBookingApi(put, "/appointment", {
    newAppointment,
    currentAppointment,
    action: "reschedule",
  });
};
